import Vue from 'vue'
import VueRouter from 'vue-router'

import { default as VHome }  from '../views/Home.vue'
import { default as VLogin } from '../views/Login.vue'
import { default as VOverview } from '../views/Overview.vue'
import { default as VError } from '../views/Error.vue'
import { default as VAccount } from '../views/Account.vue'
import { default as VFaq } from '../views/Faq.vue'
import { default as VMessages } from '../views/Messages.vue'
import { default as VPayments } from '../views/Payments.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: VHome,
    meta: { title: 'Home' },
    redirect: () => {
      return {
        path: '/login'
      }
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: { title: 'About' }
  },
  {
    path: '/login',
    name: 'Login',
    component: VLogin,
    meta: { title: 'Login' }
  },
  {
    path: '/account',
    name: 'Account',
    component: VAccount,
    meta: { title: 'Account', requiresAuth: true }
  },
  {
    path: '/overview',
    name: 'Overview',
    component: VOverview,
    meta: { title: 'Overview', requiresAuth: true }
  },
  {
    path: '/payments',
    name: 'Payments',
    component: VPayments,
    meta: { title: 'Zahlungen', requiresAuth: true }
  },
  {
    path: '/error',
    name: 'Error',
    component: VError,
    meta: { title: 'Error' }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: VFaq,
    meta: { title: 'FAQ (Häufig gestellte Fragen)' }
  },
  {
    path: '/messages',
    name: 'Messages',
    component: VMessages,
    meta: { title: 'Nachrichten' }
  },
  {
    path: "*",
    redirect: to => {
      return {
        path: '/error',
        query: { errorCode: 0x4000, targetRoute: to.fullPath }
      }
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router